import React, {useState} from 'react'
import './Textform.css';
export default function Textform(props) {
const [text, setText] =useState(" ");


  const [myStyle , setMyStyle ] = useState ({
        color: 'white',
        backgroundColor: 'black'
       
    })
    
    const [btnTxt, setBtnText] = useState('Enable Light Mode')



    const toggleStyle = ()=>{
        if(myStyle.color ==='white'){

            setMyStyle({
                color:'black',
                backgroundColor:'white',
              
            })
            setBtnText("Enable Light Mode");
        }
            else
                setMyStyle({
                    color:'white',
                    backgroundColor:'black',
                      border:' solid white'
                     
                })
                setBtnText("Enable Dark Mode");
            
    }
    
const handleUpClick= ()=>{
    let newText=text.toUpperCase();
    setText(newText)
    props.showAlert("Successfully Converted to Uppercase",'success');
}
const handleClearClick= ()=>{
    let newText=('')
    setText(newText)
    props.showAlert("Successfully Converted to Cleartext",'success');
}
const handleOnChange =(event)=>{
    console.log("Onchange")
    setText(event.target.value);
   
}

const handleLowClick= ()=>{
    let newText=text.toLowerCase();
    setText(newText)
    props.showAlert("Successfully Converted to LowerCase",'success');
}
const handleEmailClick = () => {
    const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
    const extractedEmails = text.match(emailRegex);
    if (extractedEmails) {
        setText(`Extracted Email: ${extractedEmails.join(", ")}`);
    } else {
        setText("No valid email found.");
        props.showAlert("Successfully Extracted Email",'success');
    }
};
  return (
    <>
  <div className={`textform-container ${props.mode}`}>

<div className="mb-2" style={{color:props.mode==='dark'?'white':'#00008b'}}>
    <h1>{props.heading}</h1>
  <label htmlFor="exampleFormControlTextarea1"    class="form-label"></label>
  <textarea className="form-control"  value={text} onChange={handleOnChange}id="mybox" rows="20"></textarea>
</div>
    <div>
        <div className="container" style={{color:props.mode==='dark'?'white':'#00008b',}}></div>
    
        <div className=''></div>
      <button className='btn btn-primary mx-2'onClick={handleUpClick}>Convert to Uppercase</button>
      <button className='btn btn-primary mx-2'onClick={handleLowClick}>Convert to Lowercase</button>
      <button className='btn btn-primary mx-2'onClick={handleEmailClick}>Extracting the email</button>
      <button className='btn btn-primary mx-2'onClick={handleClearClick}>Cleartext</button>
      
    </div>
    <div>
        <h2 style={{color:props.mode==='dark'?'white':'grey',}}>Your Information 
        <p>{text.split(" ").length}words and {text.length}characters</p>
        <p>{0.0008* text.split(" ").length}Minutes Read</p></h2>
        <div className="container">
           <h1 style={{color:props.mode==='dark'?'white':'grey'}}>Preview</h1> {text}
        </div>
        

       
            <div className="container mb-1  " ></div>
    <button onClick={toggleStyle}type="button" className="btn btn-primary">{btnTxt}</button>

    </div>
    </div>
    </>
  )
}
